import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { sprintf } from 'sprintf-js';
import { Observable } from 'rxjs';

import { environment } from '../../environments/environment';
import { BaseService } from './base.service';

@Injectable()
export class SpeakerApprovalGroupService extends BaseService {

  constructor(
    protected http: HttpClient,
  ) {
    super(http, `${environment.apiBaseUrl}/companies/%(company_id)s/speaker_approval_groups`);
  }

  setDefault(id, urlParams: any, apiParams: any = {}): Observable<any> {
    const url = sprintf(this.baseUrl, urlParams) + `/default`;
    return this.http.post<any>(url, { id }, {
      params: this.toHttpParams(apiParams),
    });
  }
}
